import React from 'react';
import Eric from '../../upload/eric-duval.jpg';
import LouisVictor from '../../upload/louis-victor-duval.jpg';
import Pauline from '../../upload/pauline-duval.jpg';
import classes from './Zoom.module.scss';

class Zoom1 extends React.Component {
	render() {
		return (
			<>
				<div className={classes.Gradient}>
					<div className={classes.Title}>Histoire</div>
					<div className={classes.SecondaryTitle}>
						25 ans d'une histoire unique. <br />
						Notre groupe familial ne cesse <br />
						d'entreprendre et d'investir <br />
						pour un avenir meilleur.
					</div>
				</div>
				<div className={classes.Content}>
					<div className={classes.CenterHolder}>
						<div className={classes.BlockCenter}>
							<b>Le Groupe Duval</b> est aujourd'hui, et sera demain encore, un
							acteur clef du marché de l'immobilier grâce à la diversité de ses
							expertises, l’excellence de son accompagnement et la réussite de
							ses projets. Internationalisé, notre Groupe investit dans les
							territoires, valorise leur attractivité, soutient l'innovation et
							place au coeur de son positionnement, la construction d'une
							société durable. Ainsi, casse les codes et se distingue sur tous
							les grands marchés.
						</div>
					</div>
					<div className={classes.FlexHolder}>
						<div className={classes.Portrait}>
							<img src={Eric} alt="portrait-eric-duval" />
							<div className={classes.Quote}>
								« La force d’un groupe repose sur les valeurs humaines qui l’animent et l’engagement de nos équipes me le démontre chaque jour. Nous vous souhaitons une belle année 2021. »{' '}
							</div>
							<div className={classes.Name}>
								Eric Duval,
								<br />
								Président - Fondateur
							</div>
						</div>
						<div className={classes.Portrait}>
							<img src={Pauline} alt="portrait-pauline-duval" />
							<div className={classes.Quote}>
								« Notre stratégie repose sur un accompagnement actif et durable
								de nos participations et d’un alignement d’intérêts entre
								l’ensemble des parties prenantes que nous perpétuerons encore en 2021»
							</div>
							<div className={classes.Name}>
								Pauline Duval,
								<br />
								Directrice Générale
							</div>
						</div>
						<div className={classes.Portrait}>
							<img src={LouisVictor} alt="portrait-louis-victor-duval" />
							<div className={classes.Quote}>
								« Notre Groupe familial s'est transformé et digitalisé pour accompagner nos clients dans tous nos métiers tout en restant ancré au coeur des territoires. C’est un honneur de prendre la Direction de la stratégie et du développement pour cette nouvelle année. »
							</div>
							<div className={classes.Name}>
								Louis Victor Duval,
								<br />
								Directeur de la stratégie et du développement
							</div>
						</div>
					</div>
					<div className={classes.CenterHolder}>
						<div className={classes.LinkHolder}>
							<div className={classes.Weblink}>groupeduval.com</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default Zoom1;
